module.exports = __webpack_public_path__ + "img/pers-labels-eco-responsables.4418f6b5.jpg";